// @vendors
const Immutable = require('immutable');
// @constants
const actionTypes = require('constants/actionTypes');
// @utilities

function setInitialState() {
    return Immutable.fromJS({});
}

const flagBasedMBFeatures = (state = setInitialState(), action) => {
  switch (action.type) {
    case actionTypes.FLAG_BASED_MB_FEATURES_REQUEST:
      return state.merge({
        isFetching: true,
        successfully: false,
        hasError: false,
        error: '',
      });
    case actionTypes.FLAG_BASED_MB_FEATURES_SUCCESS:
      return state.merge(
        {
          isFetching: false,
          hasBeenFetched: true,
          error: '',
        },
        action.payload.flags
      );
    case actionTypes.FLAG_BASED_MB_FEATURES_ERROR:
      return state.merge({
        isFetching: false,
        hasError: true,
        error: action.payload.error,
      });
    default:
      return state;
  }
};

module.exports = flagBasedMBFeatures;
